import { render } from "./FreeToPlay.vue?vue&type=template&id=26a8744a"
const script = {}
script.render = render

export default script